import * as log from 'loglevel'

const isProduction = process.env.REACT_APP_ENV === 'production';
if (isProduction) {
    log.setLevel('warn');
} else {
    log.setLevel('trace');
}

var remote = require('loglevel-plugin-remote');

const opts = {
    url: process.env.REACT_APP_API_URI + '/logger/log',
    method: 'POST',
    headers: {},
    token: '',
    onUnauthorized: failedToken => { },
    timeout: 0,
    interval: 5000,
    level: 'trace',
    backoff: {
        multiplier: 2,
        jitter: 0.1,
        limit: 60000,
    },
    capacity: 500,
    stacktrace: {
        levels: ['trace', 'warn', 'error'],
        depth: 3,
        excess: 0,
    },
    timestamp: () => new Date().toISOString(),
    format: remote.json,
};

remote.apply(log, opts);


export { log };
